// utils/Masks.js
export const maskCpfCnpj = (value) => {
  if (!value) return ""
  const cleanValue = value.replace(/\D/g, "")
  if (cleanValue.length <= 11) {
    // CPF
    return cleanValue
      .replace(/(\d{3})(\d)/, "$1.$2")
      .replace(/(\d{3})(\d)/, "$1.$2")
      .replace(/(\d{3})(\d{1,2})$/, "$1-$2")
  } else {
    // CNPJ
    return cleanValue
      .replace(/^(\d{2})(\d)/, "$1.$2")
      .replace(/^(\d{2})\.(\d{3})(\d)/, "$1.$2.$3")
      .replace(/\.(\d{3})(\d)/, ".$1/$2")
      .replace(/(\d{4})(\d)/, "$1-$2")
  }
}

export const maskPhone = (value) => {
  if (!value) return ""
  const cleanValue = value.replace(/\D/g, "")
  if (cleanValue.length <= 10) {
    // Telefone fixo ou celular sem 9º dígito
    return cleanValue.replace(/^(\d{2})(\d{4})(\d{4})$/, "($1) $2-$3")
  } else {
    // Celular com 9º dígito
    return cleanValue.replace(/^(\d{2})(\d{5})(\d{4})$/, "($1) $2-$3")
  }
}

export const maskCep = (value) => {
  if (!value) return ""
  const cleanValue = value.replace(/\D/g, "")
  return cleanValue.replace(/^(\d{5})(\d)/, "$1-$2")
}

const dateMask = (value) => {
  return value.replace(/\D/g, '')
    .replace(/^(\d{2})(\d)/, '$1/$2')
    .replace(/(\d{2}\/\d{2})(\d)/, '$1/$2');
}

export {
  dateMask
}